export interface TierDiscountDefaultSettings {
  widgetId?: string;
  tenantId?: string;
  bundleBadgeColor: string;
  bundleBadgeText: string;
  bundleBadgeTextColor: string;
  bundleImageData: string;
  bundleImageLink: string;
  bundleImageType: 'single' | 'multiple';
  titleName: string;
  templateType: 'default' | 'customization';
  titleAlignment: 'center' | 'left' | 'right';
  titleTextColor: string;
  titleFont: string;
  titleTextTransform: 'capitalize' | 'uppercase' | 'lowercase' | 'none';
  titleFontStyle: 'regular' | 'bold' | 'italic';
  titleFontSize: number;
  buttonBackgroundColor: string;
  buttonText: string;
  buttonTextColor: string;
  description: string;
  bundleHighlightOption?: number;
  variantSelection?: 'single' | 'multiple';
  isDefault?: boolean;
}

export interface TierDiscountWidgetDesignSettings extends Partial<TierDiscountDefaultSettings> {
  titleFontWeight?: string | number;
}

export class TierDiscountModel {
  constructor(public properties: TierDiscountModelProperties) {}
}

export interface TierDiscountModelProperties {
  widgetId: string;
  bundle_type: 'tiered';
  discount_value: number;
  discount_type: string;
  bundle_display_type: string;
  threshold_type?: 'quantity' | 'subtotal';
  updated_at: number;
  discounts: TierDiscount[];
  products: TierDiscountProduct[];
  excludes?: any[];
  widgetDesignSettings?: TierDiscountWidgetDesignSettings;
  currentTotalQuantity?: number;
  currentTotalValue?: number;
  hasDiscount?: boolean;
  addedItems?: AddedItem[];
  finalTotal?: number;
  originalTotal?: number;
}

export interface TierDiscount {
  item: number;
  discount_type: 'percentage' | 'amount';
  discount_value: string;
  achieved?: boolean;
}

export interface TierDiscountProduct {
  id: number;
  title: string;
  handle: string;
  vendor: string;
  product_type: string;
  available: boolean;
  price_min: number;
  price_max: number;
  body_html: string;
  tags: string[];
  images_info: ProductImage[];
  images: Record<string, string>;
  variants: ProductVariant[];
  options_with_values: ProductOption[];
  bundle_matched?: boolean;
  addedVariants?: AddedVariant[];
}

export interface ProductImage {
  src: string;
  width: number;
  height: number;
  alt: string | null;
  id: number;
  position: number;
}

export interface ProductVariant {
  id: number;
  title: string;
  price: string;
  compare_at_price: string;
  available: boolean;
  sku: string | null;
  barcode: string | null;
  inventory_quantity: number;
  inventory_management: string | null;
  inventory_policy: 'deny' | 'continue';
  image: string | null;
  weight: number;
  weight_unit: string;
  option1: string | null;
  option2: string | null;
  option3: string | null;
}

export interface ProductOption {
  name: string;
  values: string[];
  position: number;
}

export interface AddedVariant {
  id: number;
  title: string;
  price: string;
  quantity: number;
  productId: number;
  image?: string;
}

export interface AddedItem {
  id: number;
  title: string;
  image: string;
  price: string;
  quantity: number;
}

export interface TierDiscountTranslation {
  'tier_discount.congrats_message'?: string;
  'tier_discount.unlock_message'?: string;
  'tier_discount.add_to_cart'?: string;
  'tier_discount.checkout'?: string;
  'tier_discount.items_added'?: string;
  'tier_discount.see_all'?: string;
  'tier_discount.total_price'?: string;
  'tier_discount.close'?: string;
  'tier_discount.select_variant'?: string;
}

export interface ExtendedTierDiscountModelProperties extends TierDiscountModelProperties {
  hasDiscount: boolean;
  currentDiscountPercent?: number;
  currentTier?: number;
  progressPercent?: number;
  itemsToNextTier?: number;
}

export interface TierDiscountWidgetControllerProps {
  widgetId: string;
  productId?: number;
  collectionId?: number;
  config?: Partial<TierDiscountWidgetDesignSettings>;
}

export interface TierDiscountWidgetControllerState {
  loading: boolean;
  model?: TierDiscountModel;
  error?: Error;
  rendered: boolean;
}
